export const isDefined = <T>(v: T | undefined): v is T => v !== undefined;
